var _rect, _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndusSystemRouterTalentlenzIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 26,
    fill: "#FCEAF2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 35,
    r: 11,
    stroke: "#EE5A9B",
    strokeWidth: 5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 42,
    r: 8,
    stroke: "#EE5A9B",
    strokeWidth: 5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 42,
    r: 8,
    stroke: "#EE5A9B",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 74c2-16 8-23 17-23s15 7 17 23M12 71c1-12 6-19 14-19M84 71c-1-12-6-19-14-19",
    stroke: "#EE5A9B",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndusSystemRouterTalentlenzIcon);
export default __webpack_public_path__ + "static/media/andus-system-router-talentlenz-icon.4b2e03fdaa61f9c851927675db79b722.svg";
export { ForwardRef as ReactComponent };